/**
 * lib/submitLead.js
 * Shared Analytos lead form — POSTs to the deployed Google Apps Script,
 * which appends a row to the shared Google Sheet (tab "Leads").
 * Per the global google-sheets-lead-form guide: same URL + secret across
 * every product; do NOT create a new Apps Script deployment.
 */

const APPS_SCRIPT_URL    = import.meta.env.VITE_GOOGLE_APPS_SCRIPT_URL?.trim();
const APPS_SCRIPT_SECRET = import.meta.env.VITE_GOOGLE_APPS_SCRIPT_SECRET?.trim();

export async function submitLead({ full_name, email, phone, message, product, company, source }) {
  if (!APPS_SCRIPT_URL || !APPS_SCRIPT_SECRET) {
    throw new Error('Lead form is not configured');
  }

  const response = await fetch(APPS_SCRIPT_URL, {
    method: 'POST',
    // text/plain avoids a CORS preflight against Apps Script — do NOT change to application/json
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({
      secret: APPS_SCRIPT_SECRET,
      full_name,
      email,
      phone,
      message,
      product,
      company,
      source,
    }),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.error) {
    throw new Error(payload.error || 'Failed to submit lead');
  }
}
